<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pt-0 tw-flex tw-items-center">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Merchant Account</h1>
      </base-content>
    </div>
    <base-content>
      <inline-error class="tw-my-3" id="stripe-connect-error" title="Error" :message="errorMessage" :error="error" />
      <base-card class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between">
          <div class="tw-text-lg tw-text-gray-700 tw-font-normal tw-mb-6">{{ statusMessage }}</div>
          <div>
            <div v-if="overallStatus === 'working'" class="tw-flex tw-items-center">
              <base-spinner :size="16" />
            </div>
            <base-badge v-else-if="overallStatus == 'success'" color="green">Connected</base-badge>
            <base-badge v-else color="red">Failed</base-badge>
          </div>
        </div>
        <div class="tw-flex tw-justify-between tw-mb-6">
          <div class="tw-text-gray-700 tw-font-light">Securing Connection to Stripe</div>
          <div>
            <div v-if="connectStatus === 'working'" class="tw-flex tw-items-center">
              <base-spinner :size="16" />
            </div>
            <base-badge v-if="connectStatus == 'success'" color="green">Connected</base-badge>
            <base-badge v-if="connectStatus == 'failed'" color="red">Not Connected</base-badge>
          </div>
        </div>
        <div class="tw-flex tw-justify-between tw-mb-6">
          <div class="tw-text-gray-700 tw-font-light">Synchronizing offered plans to Stripe</div>
          <div>
            <div v-if="linkPlansStatus === 'working'" class="tw-flex tw-items-center">
              <base-spinner :size="16" />
            </div>
            <base-badge v-if="linkPlansStatus == 'success'" color="green">Synced</base-badge>
            <base-badge v-if="linkPlansStatus == 'failed'" color="red">Not Synced</base-badge>
          </div>
        </div>
        <div class="tw-flex tw-justify-between tw-mb-6">
          <div class="tw-text-gray-700 tw-font-light">Synchronizing locations to Stripe</div>
          <div>
            <div v-if="linkLocationsStatus === 'working'" class="tw-flex tw-items-center">
              <base-spinner :size="16" />
            </div>
            <base-badge v-if="linkLocationsStatus == 'success'" color="green">Synced</base-badge>
            <base-badge v-if="linkLocationsStatus == 'failed'" color="red">Not Synced</base-badge>
          </div>
        </div>
      </base-card>
    </base-content>
  </div>
</template>

<script>
import EventBus from "@/utils/global-events.js";
import InlineError from "@/components/InlineError";

export default {
  name: "StripeConnectResponse",
  components: {
    InlineError,
  },
  data() {
    return {
      showError: false,
      errorTitle: "",
      errorMessage: "",
      error: {},
      statusMessage: "Connecting Stripe to Predictile",
      connectStatus: "none",
      linkPlansStatus: "none",
      linkLocationsStatus: "none",
      overallStatus: "none",
    };
  },
  mounted() {
    this.captureResponse(this.$route.query);
  },
  computed: {
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Merchant Account" }];
    },
  },
  methods: {
    async captureResponse(params) {
      if (Object.prototype.hasOwnProperty.call(params, "error")) {
        this.error = params.error;
        this.errorMessage = params.error_description;
        this.showError = true;
      }
      if (Object.prototype.hasOwnProperty.call(params, "code")) {
        this.overallStatus = "working";

        if (this.overallStatus === "working") await this.connectAccounts(params.code, params.state);

        if (this.overallStatus === "working") await this.LinkPlans(params.state);

        if (this.overallStatus === "working") await this.LinkLocations(params.state);
      }
    },
    async connectAccounts(authorizationCode, businessId) {
      this.connectStatus = "working";

      await this.$axios
        .post(`/businesses/${businessId}/stripe/connectaccount`, { authorizationCode: authorizationCode })
        .then(() => {
          this.connectStatus = "success";
        })
        .catch((err) => {
          this.error = err.response.data;
          this.errorMessage = err.message;
          this.showError = true;
          this.connectStatus = "failed";
          this.overallStatus = "failed";
        });
    },
    async LinkPlans(businessId) {
      this.linkPlansStatus = "working";

      await this.$axios
        .post(`/businesses/${businessId}/stripe/connectplans`)
        .then(() => {
          this.linkPlansStatus = "success";
        })
        .catch((err) => {
          this.errorTitle = err.response.data;
          this.errorMessage = err.message;
          this.showError = true;
          this.linkPlansStatus = "failed";
          this.overallStatus = "failed";
        });
    },
    async LinkLocations(businessId) {
      this.linkLocationsStatus = "working";

      await this.$axios
        .post(`/businesses/${businessId}/stripe/connectlocations`)
        .then(() => {
          this.linkLocationsStatus = "success";
          this.overallStatus = "success";
          setTimeout(function() {}, 1000);
          this.href(`/businesses/${businessId}/business/merchant`);
          EventBus.$emit("GLOBAL_NOTIFY", { title: "Stripe Connected", message: "Your Stripe account is now connected!" });
        })
        .catch((err) => {
          this.errorTitle = err.response.data;
          this.errorMessage = err.message;
          this.linkLocationsStatus = "failed";
          this.overallStatus = "failed";
        });
    },
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
